

























import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    components: {
        iwInputGroupStepper: iwInputGroupStepper,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            pathInStore: "property.building.annexCount",
            pathInStoreUI: "property.hasOutbuildings",
            inputName: "annex-count",
            specificId: uuidv4() as string
        };
    },
    computed: {
        annexCount: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        hasOutbuildings: function(): boolean {
            return this.$store.getters["FormModule/getValueUI"](this.pathInStoreUI);
        }
    },
    methods: {
        updateValue: function(annexCount: number): void {
            if (!this.hasOutbuildings || annexCount === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": annexCount});
            }
        }
    }
});

